var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.985,
    height: 12.985,
    viewBox: "0 0 12.985 12.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-crop",
    "data-name": "Icon ionic-md-crop",
    d: "M12.864,11.638h1.18V6.871a1.183,1.183,0,0,0-1.18-1.18H8.1v1.18h4.766ZM6.871,12.683V3.375H5.691V5.691H3.375v1.18H5.691v5.812a1.183,1.183,0,0,0,1.18,1.18h5.993v2.5h1.18v-2.5H16.36v-1.18Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.1d90a91bbcc8ea5f427216c8a3fdeb20.svg";
export { ForwardRef as ReactComponent };